import axios, {AxiosInstance} from 'axios';
import config from '@/appConfig.json';
import {User, UserResponse, MessageResponse} from '@/store/models';

export default class UserService {

    /**
     * Get instance of UserService for querying users from api.
     */
    public static getInstance(): UserService {
        return new this();
    }

    private resourceUrl: string = '/users/';
    private authResourceUrl: string = '/auth/';

    private axiosConfig = {
        baseURL: config.apiUrl,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.accessToken
        }
    };

    /**
     * Create an axios instance with necessary config.
     */
    private apiClient: AxiosInstance = axios.create(this.axiosConfig);

    /**
     * Fetch user by id from api.
     *
     * @param id
     */
    public async getUser(): Promise<User | number> {
        try {
            const response = await UserService.getInstance().apiClient.post(this.authResourceUrl + 'me');
            return (response.data as User);
        } catch (ex) {
            return ex.response.status;
        }
    }

    /**
     * Save user data.
     *
     * @param user
     */
    public async saveUser(user: User): Promise<User> {
        const response = await this.apiClient.put(this.resourceUrl + user.id, user);
        return (response.data as User);
    }

    /**
     * Log in User by token
     *
     * @param token
     */
    public async loginUser(token: string) {
        const response = await this.apiClient.post(
            this.authResourceUrl + 'login',
            {
                token,
                password: 'noPassword'
            });

        return response;
    }

    /**
     * Get User with new token
     */
    public async refreshAccessToken() {
        try {
            const response = await UserService.getInstance().apiClient.post(this.authResourceUrl + 'refresh');
            return (response.data as UserResponse);
        } catch (ex) {
            return ex;
        }
    }

    public async logOutUser(): Promise<MessageResponse> {
        try {
            const response = await UserService.getInstance().apiClient.post(this.authResourceUrl + 'logout');
            return (response.data as MessageResponse);
        } catch (ex) {
            return ex;
        }
    }
}
